module.exports = __webpack_public_path__ + "img/black_airplane_label.1cb7826c.png";